// TemplateMetadataContext.jsx
// Context for template-level metadata (subject, preheader, etc.)
// Provides hook access similar to email builder's useDocument() pattern
import React, { createContext, useContext } from 'react';

const TemplateMetadataContext = createContext(null);

export const TemplateMetadataProvider = ({ children, value }) => {
  return (
    <TemplateMetadataContext.Provider value={value}>
      {children}
    </TemplateMetadataContext.Provider>
  );
};

export const useTemplateMetadata = () => {
  const context = useContext(TemplateMetadataContext);
  if (!context) {
    throw new Error('useTemplateMetadata must be used within TemplateMetadataProvider');
  }
  return context;
};
